var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQueueExit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "inherit",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5556 20V17.6H13.3333V14.4H19.5556V12L24 16L19.5556 20ZM17.7778 8C18.2493 8 18.7015 8.16857 19.0349 8.46863C19.3683 8.76869 19.5556 9.17565 19.5556 9.6V11.2H17.7778V9.6H9.77778V22.4H17.7778V20.8H19.5556V22.4C19.5556 22.8243 19.3683 23.2313 19.0349 23.5314C18.7015 23.8314 18.2493 24 17.7778 24H9.77778C9.30628 24 8.8541 23.8314 8.5207 23.5314C8.1873 23.2313 8 22.8243 8 22.4V9.6C8 9.17565 8.1873 8.76869 8.5207 8.46863C8.8541 8.16857 9.30628 8 9.77778 8H17.7778Z",
    fill: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQueueExit);
export default __webpack_public_path__ + "static/media/queue_exit.df2465d1cd79be40975c54718c4dab91.svg";
export { ForwardRef as ReactComponent };